import HeaderAd from '../elements/HeaderAd'
import { ProductDisplay } from '../elements/ProductDisplay'
import { getCampaignUrl } from '../../helpers'

export const ProductAds = ({ ads }: { ads: ProductAd[] }) => (
  <section className="d-flex flex-column gap-2">
    {ads.map(ad => (
      <article key={ad.ad_id}>
        <HeaderAd
          campaignURL={getCampaignUrl(ad.click_url)}
          campaignName={ad.campaign_name}
        />
        <ProductDisplay
          product_name={ad.product_name}
          product_sku={ad.product_sku}
          seller_id={ad.seller_id}
        />
      </article>
    ))}
  </section>
)
